import { Components, Theme } from '@mui/material';

export const menuItemStyles: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-selected': {
        backgroundColor: theme.palette.customGrey.light
      },
      '&:first-of-type': {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px'
      },
      '&:last-of-type': {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px'
      }
    })
  }
};
